module.exports = ".errormsg{\n\tcolor:red;\n}"